import { Button } from '@kerfjs/ui/button';
import { px } from '@kerfjs/ui/css-values';
import { Grid } from '@kerfjs/ui/grid';
import { List } from '@kerfjs/ui/list';
import { StateBanner } from '@kerfjs/ui/state-banner';
import { DialogSurface } from '@kerfjs/ui/surface-scaffold';
import { TextField } from '@kerfjs/ui/text-field';
import type { SafeHtml } from 'kerfjs';

import { assumptionsDialog, assumptionsMessage, assumptionsSubmitting } from '../../../data/state.js';

/** A report-scoped draft; only Save writes demand overrides. */
export function AssumptionsDialog(): SafeHtml {
  const draft = assumptionsDialog.value;
  if (draft === null) return <></>;
  const labels: Record<string, string> = {
    customsDutyPct: 'Duty % · AI',
    salesTaxPct: 'Tax %',
    inlandFreight: 'Inland',
  };
  return (
    <DialogSurface
      label="Edit Assumptions"
      className="assumptions-dialog"
      rootAttributes={{
        'data-action': 'assumptions-dialog',
        'data-unsaved-guard': 'these assumptions',
        'data-dialog-busy': String(assumptionsSubmitting.value),
        'data-auto-open-dialog': '',
      }}
      footer={
        <>
          <Button
            tone="neutral"
            size="default"
            emphasis="plain"
            action="cancel-analysis-assumptions"
            disabled={assumptionsSubmitting.value}
            rootAttributes={{ 'data-unsaved-cancel': '', 'data-dialog-close': '' }}
          >
            Cancel
          </Button>
          <Button
            size="default"
            tone="brand"
            emphasis="primary"
            action="save-analysis-assumptions"
            loading={assumptionsSubmitting.value}
            rootAttributes={{ 'data-unsaved-save': '' }}
          >
            Save Assumptions
          </Button>
        </>
      }
    >
      <List gap="m">
        {assumptionsMessage.value !== '' ? <StateBanner tone="danger" title={assumptionsMessage.value} /> : null}
        <Grid minColumnWidth={px(180)} gap="m">
          {Object.entries(draft.values).map(([field, value]) => (
            <TextField
              type="number"
              step="any"
              label={field.startsWith('fx:') ? `${field.slice(3)}→${draft.base}` : (labels[field] ?? field)}
              value={value}
              disabled={assumptionsSubmitting.value}
              rootAttributes={{ 'data-assumption': field }}
            />
          ))}
        </Grid>
      </List>
    </DialogSurface>
  );
}
